import React from 'react';
import clsx from 'clsx';
import {
  Checkbox,
  Typography,
  TYPOGRAPHY_TOKENS,
  COLORS,
} from 'pvs-design-system';
import normalizeLocationId from 'components/LocationTree/utils/normalizeLocationId';
import type { LeafProps, Location } from '../../types';
import style from './LocationTreeLeaf.module.css';
import { useLocationTreeContext } from '../../context/LocationTreeContext';

const LocationTreeLeaf: React.FC<LeafProps> = ({
  id,
  name,
  path,
  locationLevel,
  depth,
}) => {
  const { selectedLocations, onSelectedChange, focusedNodeId } =
    useLocationTreeContext();
  const checkboxId = `location-tree-checkbox-${id}`;

  const normalizedId = normalizeLocationId(id);
  const isFocused = focusedNodeId === normalizedId;
  const isChecked = selectedLocations.some(
    (loc: Location) => normalizeLocationId(loc.id) === normalizedId
  );

  return (
    <div
      className={clsx(style.locationTreeLeaf, isFocused && style.focused)}
      style={
        {
          '--depth': depth,
          '--focus-color': COLORS.purple[100],
        } as React.CSSProperties
      }
    >
      <div className={style.contentWrapper}>
        <Checkbox
          tabIndex={-1}
          color="primary"
          id={checkboxId}
          inputProps={{ 'aria-label': `Select ${name}` }}
          aria-label={`Select ${name}`}
          checked={isChecked}
          onChange={() => onSelectedChange({ id, name, path, locationLevel })}
        />
        <Typography variant="p-md" sx={{ ...TYPOGRAPHY_TOKENS['p-md'] }}>
          {name}
        </Typography>
      </div>
    </div>
  );
};
export default LocationTreeLeaf;
